import { useFlags } from "launchdarkly-react-client-sdk";

import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";
import { useAgentsEnabledFlag } from "src/pages/agents/hooks/use-agents-enabled-flag";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";

/**
 * Any integration flag is enough to reach the External context tab. Gating on
 * the surface flag alone would strand workspaces with another source enabled.
 *
 * The product gate is any of Data Agents, Ad Studio, or Lifecycle Studio.
 *
 * The tab and its routes must agree, so both read this hook.
 */
export function useExternalContextEnabled(): boolean {
  const {
    gitExternalContext,
    showExternalContextSourcesContextHub,
    warehouseSemanticLayerContext,
  } = useFlags();
  const isAgentsEnabled = useAgentsEnabledFlag();
  const isAdStudioEnabled = useIsAdStudioEnabled();
  const isLifecycleStudioEnabled = useLifecycleStudioEnabled();

  return Boolean(
    (gitExternalContext ||
      showExternalContextSourcesContextHub ||
      warehouseSemanticLayerContext) &&
      (isAgentsEnabled || isAdStudioEnabled || isLifecycleStudioEnabled),
  );
}
